const isInStoreApp = !!(window as any).__aigleinstoreapp;

export { isInStoreApp };
